/* istanbul ignore file */
export { default as StartTimedExamInstructions } from './StartTimedExamInstructions';
export { default as SubmitTimedExamInstructions } from './SubmitTimedExamInstructions';
export { default as SubmittedTimedExamInstructions } from '../../plugin-slots/SubmittedTimedExamInstructionsSlot';
export { default as TimedExamFooter } from './TimedExamFooter';
